__turbopack_context__.v({
  "Action": "_7YGNeG_Action",
  "ActionIcon": "_7YGNeG_ActionIcon",
  "Actions": "_7YGNeG_Actions",
  "Panel": "_7YGNeG_Panel",
  "Root": "_7YGNeG_Root",
  "skeleton-loading": "_7YGNeG_skeleton-loading",
});
